// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hXIe","content":"styles_content__XYLZ5","row":"styles_row__3WnbJ","footer":"styles_footer__1iz1P","phraseLength":"styles_phraseLength__1T2Y4"};